import { PlanFeature, SubscriptionPlan } from "@/constants/plans";
import { Model } from "@/types/models";

import { isPlanFeatureEnabled } from "./isPlanFeatureEnabled";

/**
 * Returns whether the model tier is included in the user's subscription (e.g. Pro models on Advanced).
 */
export function isModelAvailableForSubscriptionPlan(
  model: Pick<Model, "tier">,
  plan: SubscriptionPlan | null | undefined,
): boolean {
  if (model.tier !== "pro") {
    return true;
  }

  return isPlanFeatureEnabled({ feature: PlanFeature.ProModel, plan });
}
